import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ButtonPadding, ButtonVariant } from '@app/components/button/button.component';

@Component({
  selector: 'pl-home-section',
  templateUrl: './homeSection.component.html',
})
export class HomeSectionComponent {
  @Input() public title: string | null = null;
  @Input() public text: string | null = null;
  @Input() public buttonLabel: string | null = null;
  @Output() public buttonClicked: EventEmitter<void> = new EventEmitter<void>();

  public readonly ButtonVariant: typeof ButtonVariant = ButtonVariant;
  public readonly ButtonPadding: typeof ButtonPadding = ButtonPadding;

  @HostBinding('class') public classes: string = 'block flex-1';

  public onButtonClicked(): void {
    this.buttonClicked.emit();
  }
}
